import React from "react";
import { Check, X } from "lucide-react";

const Comparison = () => {
  return (
    <section className="py-24 px-4 bg-slate-900">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            The Smarter Way to Build Your Brand
          </h2>
          <p className="text-slate-400">
            Why spend thousands when AI can deliver the same insights?
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {/* Traditional Way */}
          <div className="bg-slate-800/50 border border-slate-700 rounded-2xl p-8">
            <div className="text-center mb-8">
              <p className="text-slate-400 text-sm mb-2">Traditional Agencies</p>
              <p className="text-4xl font-bold text-slate-500 line-through">$15,000+</p>
              <p className="text-slate-500 text-sm mt-1">4-8 weeks delivery</p>
            </div>
            <ul className="space-y-4">
              {[
                "Long discovery meetings",
                "Weeks of back-and-forth",
                "Generic templates",
                "Limited revisions",
                "No local market data",
              ].map((item, i) => (
                <li key={i} className="flex items-center gap-3 text-slate-400">
                  <X className="w-5 h-5 text-red-400 flex-shrink-0" />
                  {item}
                </li>
              ))}
            </ul>
          </div>

          {/* LocaLeap Way */}
          <div className="bg-gradient-to-br from-emerald-900/30 to-slate-900 border-2 border-emerald-500/50 rounded-2xl p-8 relative overflow-hidden">
            <div className="absolute top-4 right-4 bg-emerald-500 text-white text-xs font-bold px-3 py-1 rounded-full">
              RECOMMENDED
            </div>
            <div className="text-center mb-8">
              <p className="text-emerald-400 text-sm mb-2">LocaLeap AI</p>
              <p className="text-4xl font-bold text-white">$97</p>
              <p className="text-emerald-400 text-sm mt-1">Ready in minutes</p>
            </div>
            <ul className="space-y-4">
              {[
                "Instant AI analysis",
                "Results in 2 minutes",
                "Tailored to your business",
                "Unlimited iterations",
                "Real Google Reviews data",
              ].map((item, i) => (
                <li key={i} className="flex items-center gap-3 text-slate-200">
                  <Check className="w-5 h-5 text-emerald-400 flex-shrink-0" />
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Comparison;
